import{useConfigStore as t}from"@phx-husky/auth-context";const o=()=>{const{config:o}=t(),{translations:e,fieldsSetup:n,renderLogo:r}=o;return{translations:e,fieldsSetup:n,renderLogo:r}};export{o as useConfig};
